import React, { useEffect, useRef, useState } from 'react';
import Cross from '../../../../Assets/Modals/closeIcon.svg';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../../Features/couponsSlice';
import ChevronDown from '../../../../Assets/ChevronDownLargeDarkMode.svg';
import { showToast } from '../../../../Components/Toaster/Toaster';
import { useLocation, useNavigate } from 'react-router-dom';
import { useOutsideClickHandler } from '../../../../Hooks/useOutsideClick';

const typeList = [
    {
        id: 'percentage-discounts',
        name: 'Percentage Discounts'
    },
    {
        id: 'fixed-discounts',
        name: 'Fixed Discounts'
    },
    {
        id: 'buy-x-get-x',
        name: 'Buy X, Get X'
    }
];

function SelectCouponType() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        handleCloseModal();
    });

    const dropdownButtonRef = useRef(null);
    const dropdownListRef = useRef(null);

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [couponType, setCouponType] = useState({});

    const handleDropdownButton = () => {
        setDropdownOpen(!dropdownOpen);
    }

    const handleCloseModal = () => {
        dispatch(closeModal());
    }

    const [buttonAvailable, setButtonAvailable] = useState(false);

    const handleSelectCouponType = (couponType) => {
        setCouponType(couponType);
    }

    const handleNext = () => {
        if(buttonAvailable) {
            navigate(`${location.pathname}/add-coupon/${couponType.id}`);
            dispatch(closeModal());
        }
        else {
            if(Object.keys(couponType).length === 0) {
                showToast('Please select coupon type.', 'warning');
            }
            return;
        }
    }

    useEffect(() => {
        if(Object.keys(couponType).length > 0) {
            setButtonAvailable(true);
        }
        else {
            setButtonAvailable(false);
        }
    }, [couponType]);

    return (
        <div ref={wrapperRef} className='w-[44%] bg-[#FFFFFF] border border-[#EAEAEA] rounded-[9px] p-4 flex flex-col gap-6'>
            <div className="flex flex-col gap-3">
                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <h1 className='font-semibold text-2xl text-[#121212]'>Select Coupon type</h1>
                        </div>

                        <button onClick={handleCloseModal} className="w-11 h-11 flex items-center justify-center">
                            <img src={Cross} alt="" />
                        </button>
                    </div>

                    <p className='font-medium text-[16px] leading-7 text-[#666666]'>Select the right coupon and its value to craft amazing deals.</p>
                </div>

                <div className="flex flex-col gap-3">
                    <h1 className='font-medium text-base text-[#121212]'>Select Coupon</h1>

                    <div onClick={handleDropdownButton} ref={dropdownButtonRef} className="relative cursor-pointer flex items-center justify-between px-3 py-4 bg-[#F5F5F5] border border-[#EAEAEA] rounded-[9px]">
                        <p className='font-normal text-base text-[#666666] select-none'>
                            {Object.keys(couponType).length > 0 ? couponType?.name : 'select coupon type'}
                        </p>

                        <div className="size-6 flex items-center justify-center select-none">
                            <img src={ChevronDown} alt="" />
                        </div>

                        {
                            dropdownOpen && 
                            <div ref={dropdownListRef} className="bg-[#FFFFFF] max-h-56 overflow-y-scroll absolute z-10 top-14 left-0 w-full rounded-[9px] shadow-[0px_3px_6px_0px_#0000001F]">
                                {typeList.map(type => {
                                    return (
                                        <p key={type.id} onClick={() => handleSelectCouponType(type)} className='px-3 py-4 font-medium text-base text-[#666666] select-none hover:bg-[#F5F5F5]'>{type.name}</p>
                                    );
                                })}
                            </div>
                        }
                    </div>
                </div>
            </div>

            <button onClick={handleNext} className={`px-4 py-2 ${buttonAvailable ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'} text-buttonText rounded font-semibold text-base`}>Next</button>
        </div>
    );
}

export default SelectCouponType;
